module.exports = __webpack_public_path__ + "img/symbol_6.35a277a3.png";